export const POPULAR = 'POPULAR';
export const FREE = 'FREE';
export const NEW = 'NEW';
export const HOMEMADE = 'HOMEMADE';